import { Card, CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';

interface CardsProp {
  title: string;
  children: React.ReactNode;
  styleType: string;
  fontWeight?: string;
}

const Cards = ({ title, children, styleType = '', fontWeight = '' }: CardsProp) => (
  <div className={`${styleType} max-h-[70vh] overflow-auto`}>
    <Card>
      <CardHeader>
        <CardTitle
          style={{
            fontWeight: fontWeight,
          }}
        >
          {title}
        </CardTitle>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  </div>
);

export default Cards;
